import { AuthRedirectModal } from "./AuthRedirectModal"
import { DevToolsModal } from "./DevToolsModal"
import { FlexStoneExample } from "./FlexStoneExample"
import { HowItWorksModal } from "./HowItWorksModal"
import { Loader } from "./Loader"
import { PrivacyPolicyModal } from "./PrivacyPolicyModal"
import { SettingsModal } from "./SettingsModal"
import { TermsOfUseModal } from "./TermsOfUseModal"

export const COMMON_MODALS = {
  pageLoading: {
    component: Loader
  },
  flexStoneExample: {
    component: FlexStoneExample
  },
  settings: {
    component: SettingsModal,
    params: {} as {
      onBack?: () => void
    }
  },
  howItWorks: {
    component: HowItWorksModal
  },
  devTools: {
    component: DevToolsModal
  },
  termsOfUse: {
    component: TermsOfUseModal
  },
  privacyPolicy: {
    component: PrivacyPolicyModal
  },
  authRedirectModal: {
    component: AuthRedirectModal,
    params: {} as {
      mode: "toLogin" | "toRegister"
      email: string
    }
  }
} as const
